import { useState } from "react"

import parse from "html-react-parser"
import { useTranslation } from "react-i18next"

import { Button } from "@/components/ui/button"
import { CourseList } from "@/features/training/components/course-list"
import { DefinitionAlert } from "@/features/training/components/definition-alert"
import { CourseLayout } from "@/features/training/components/layouts/course-layout"
import { CourseSection } from "@/features/training/components/layouts/course-section"
import { ToolsComparisonTable } from "@/features/training/components/tools-comparison-table"

export function WhatIsAIPage() {
  const { t } = useTranslation("", { keyPrefix: "training.introduction" })

  const whatIsAiBulletPointsOne = t("what_is_ai.bullet-points_1", {
    returnObjects: true,
  }) as string[]
  const whatIsAiBulletPointsTwo = t("what_is_ai.bullet-points_2", {
    returnObjects: true,
  }) as string[]

  const [aiPersonImageUrl, setAiPersonImageUrl] = useState("https://thispersondoesnotexist.com/")

  const refreshAiPersonImageUrl = () => {
    setAiPersonImageUrl("https://thispersondoesnotexist.com/?" + new Date().getTime())
  }

  return (
    <CourseLayout>
      <CourseSection>
        <h2> {t("what_is_ai.intro_to_ai")}</h2>
        <p> {parse(t("what_is_ai.intro_text_1"))} </p>
        <DefinitionAlert
          description={t("what_is_ai.what_is_ai_def2.description")}
          title={t("what_is_ai.what_is_ai_def2.title")}
        />
        <img
          alt="Description"
          className="shadow-x border-border h-auto w-full rounded-lg border"
          src="/assets/training_images/introduction/hands.jpg"
        />
      </CourseSection>

      <CourseSection>
        <h3> {t("what_is_ai.intro_to_ml")}</h3>
        <p> {parse(t("what_is_ai.intro_text_2"))} </p>
        <CourseList data={whatIsAiBulletPointsOne} />
        <p> {parse(t("what_is_ai.intro_text_4"))} </p>
        <DefinitionAlert
          description={t("what_is_ai.what_is_ai_def1.description")}
          title={t("what_is_ai.what_is_ai_def1.title")}
        />
        <img
          alt="Description"
          className="h-auto w-full rounded-[6px]"
          src="/assets/training_images/introduction/diagram.png"
        />
      </CourseSection>
      <CourseSection>
        <h3> {t("what_is_ai.intro_to_genai")}</h3>
        <p> {parse(t("what_is_ai.intro_text_5"))} </p>
        <p> {parse(t("what_is_ai.intro_text_6"))} </p>
        <div className="flex flex-col items-center gap-3">
          <img
            alt="AI-generated face"
            className="border-border w-4/6 rounded-lg"
            src={aiPersonImageUrl}
          />
          <Button variant="default" onClick={refreshAiPersonImageUrl}>
            {t("what_is_ai.refresh_image")}
          </Button>
        </div>
      </CourseSection>
      <CourseSection>
        <h3> {t("what_is_ai.title_llms")}</h3>
        <p> {parse(t("what_is_ai.intro_text_7"))} </p>
        <CourseList data={whatIsAiBulletPointsTwo} />
      </CourseSection>

      {/* Tools comparison: ChatGPT vs Copilot vs appName */}
      <CourseSection>
        <h2>{t("tools_comparison.title", "How does {{appName}} compare?")}</h2>
        <p>
          {parse(
            t(
              "tools_comparison.description",
              "All three tools use the same underlying LLM families — think different car, same engine. The key difference is where your data lives and how much control you have."
            )
          )}
        </p>
        <div className="my-4">
          <ToolsComparisonTable />
        </div>
      </CourseSection>
    </CourseLayout>
  )
}
